import * as React from 'react';
import '../styling/componentStyles.css'
import Button from '@material-ui/core/Button';

interface ButtonsProps{
    label: String;
    name: String;
    visible: Boolean;
    handleToUpdate: Function;
    disabled?:boolean;
}

export const Buttons: React.FC<ButtonsProps> = (props: ButtonsProps) =>{
    const{
        name, visible, handleToUpdate, disabled
    } = props;
    return(
        <div className='button'>
            {disabled ?
            visible &&
            <Button disabled variant="contained" onClick={() => {handleToUpdate(true)}}>
                {name}
            </Button>   
            :
            visible &&
            <Button variant="contained" onClick={() => {handleToUpdate(true)}}>
                {name}
            </Button>   
            }   
        </div>
    )
    
}

export default Buttons